import { AddPopoutSource } from 'owa-popout-v2';
import popoutCalendarReadingPane from 'owa-popout/lib/utils/popout/popoutCalendarReadingPane';

export function displayAppointmentForm(itemId: string) {
    popoutCalendarReadingPane(itemId, 'Mail_Addins', null /* data */, AddPopoutSource.Addins);
}
